export default defineNuxtRouteMiddleware(async (to) => {
	if (to.path === "/login") {
		return;
	}

	const { getToken } = useAuth();
	const token = getToken();

	if (!token && !to.path.includes("/login")) {
		const queryObject: Record<string, string> = {};

		if (to.fullPath && to.fullPath !== "/") {
			queryObject.redirect = to.fullPath;
		}

		return navigateTo({
			path: "/login",
			query: queryObject,
		});
	}
});
